import Img1 from "../assets/images/research2.png";
import Img2 from "../assets/images/thermo.jpeg";
import Img3 from "../assets/images/15-1.jpg";
export const latestEvents = [
  {
    eventsHeading: "Research Symposium",
    img: Img1,
    day: "15",
    month: "Jun",
    time: "1.00pm-4.00pm",
    location: "Faculty Building",
    eventsDetails:
      "Showcasing the department's latest research findings and providing a platform for students and faculty to present their work...",

    id: 1,
  },
  {
    eventsHeading: "Quantum Computing Workshop",
    img: Img2,
    day: "15",
    month: "Jun",
    time: "1.00pm-4.00pm",
    location: "Faculty Building",
    eventsDetails:
      "Exploring the emerging field of quantum computing and its potential applications in technology and research...",
    id: 1,
  },
  {
    eventsHeading: "Nanotechnology Seminar",
    img: Img3,
    day: "15",
    month: "Jun",
    time: "1.00pm-4.00pm",
    location: "Faculty Building",
    eventsDetails:
      "Exploring the world of nanoscience and nanotechnology and its impact on various industries",
    id: 1,
  },
];
